
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/dj-verification/[planId]",
      function () {
        return require("private-next-pages/d/account/dj-verification/[planId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/dj-verification/[planId]"])
      });
    }
  